import { render, staticRenderFns } from "./_DocTemplateCard.vue?vue&type=template&id=0a906f56&"
import script from "./_DocTemplateCard.vue?vue&type=script&lang=ts&"
export * from "./_DocTemplateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports